import { Box, Button, Popper } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

//This component is unfinished. Might be used to add CHRs to users when adding these users to a project

export const CHRSelector = ({ selected, person, project }) => {
  const { t } = useTranslation();

  const [popperAnchor, setPopperAnchor] = useState(null);

  function handleClick(e) {
    e.stopPropagation();
    console.log(e.target);

    setPopperAnchor(e.target);
  }

  return (
    <Box className="pr-5">
      {selected ? (
        <Box>
          <Button
            variant="contained"
            color="info"
            onClick={(e) => handleClick(e)}
          >
            {t('Select Calculative Hourly Rate')}
          </Button>
          <Popper open={popperAnchor}>{'test'}</Popper>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};
